function parseByRegex(text, regex) {
  if (!text) return undefined;

  const matches = text.match(regex);
  return matches ? matches[1] : undefined
}

// this is for some legacy pages, such as /site/paws/learn/sample-apps/
function parseTitleFromBreadcrumb(htmlContent) {
  const breadcrumbInnerHTML = parseByRegex(htmlContent, 
    /<div\s+class\s*=\s*['"][^'"]*breadcrumbs[^'"]*['"][^>]*>([\s\S]*?)<\/div>/i);
  
  if (!breadcrumbInnerHTML) { 
    return '';
  }

  const div = document.createElement("div");
  div.innerHTML = breadcrumbInnerHTML;
  const lastItemInBreadcrumb = div.textContent
    .split(">")
    .map(i => i.trim())
    .filter(i => !!i)
    .pop();
    
  return lastItemInBreadcrumb;
}

function parseSeoTitleTag(htmlContent) {
  return (parseByRegex(htmlContent, /<seotitle>([\s\S]*?)<\/seotitle>/i)
    || parseByRegex(htmlContent, /<pubhubtitle>([\s\S]*?)<\/pubhubtitle>/i)
    || '').trim();
}

function parseTitle(htmlContent) {
  return (parseSeoTitleTag(htmlContent)
    || parseByRegex(htmlContent, /<head>[\s\S]*?<title>([\s\S]*?)<\/title>[\s\S]*?<\/head>/i)
    || parseTitleFromBreadcrumb(htmlContent)
    || parseByRegex(htmlContent, /<h1\b[^>]*>(.*?)<\/h1>/i)
    || '').trim();
}

function parseSeoDescriptionTag(htmlContent) {
  return (parseByRegex(htmlContent, /<seodescription>([\s\S]*?)<\/seodescription>/i)
    || parseByRegex(htmlContent, /<pubhubdescription>([\s\S]*?)<\/pubhubdescription>/i)
    || '').trim();
}

function parseDescription(htmlContent) {
  return (parseSeoDescriptionTag(htmlContent)
    || parseByRegex(htmlContent, /<meta\s+name\s*=\s*["']description["']\s+content\s*=\s*["']([\s\S]*?)["']\s*\/?>/i)
    || '').trim();
}

const SEO = {
  parseSeoTitleTag,
  parseSeoDescriptionTag,
  parseTitle,
  parseDescription
};

export default SEO;